/**
 * Voice-call presentation state.
 *
 * Keeps visual state, captions, active-call layout, and accessible mute control
 * semantics separate from transport and recording lifecycle code.
 */
const $ = jQuery;

const STATE_LABELS = {
    idle: 'Ready',
    connecting: 'Connecting',
    reconnecting: 'Reconnecting',
    listening: 'Listening',
    thinking: 'Thinking',
    speaking: 'Speaking',
    muted: 'Muted',
    error: 'Needs attention',
};

const STATE_CLASSES = Object.keys(STATE_LABELS).map((state) => `is-${state}`).join(' ');

export function createVideocallExperience(options) {
    let currentState = 'idle';
    let mutedControlActive = false;

    function modal() {
        return $('#growtypeChatVideoCallModal');
    }

    function setState(stateName, caption) {
        const requestedState = STATE_LABELS[stateName] ? stateName : 'idle';
        const canOverrideMutedState = ['error', 'reconnecting'].includes(requestedState);
        const nextState = mutedControlActive && !canOverrideMutedState ? 'muted' : requestedState;
        const element = modal();

        element
            .removeClass(STATE_CLASSES)
            .addClass(`is-${nextState}`)
            .attr('data-voice-state', nextState)
            .find('.modal-videocall-state-label')
            .text(STATE_LABELS[nextState]);

        if (caption !== undefined) options.showCaption(caption);

        if (currentState !== nextState) {
            options.debugLog('Voice experience state changed', {
                from: currentState,
                to: nextState,
                transport: options.getTransport(),
            });
            currentState = nextState;
        }
    }

    function setConversationActive(value) {
        const isActive = Boolean(value);
        modal()
            .toggleClass('is-conversation-active', isActive)
            .attr('data-conversation-active', isActive ? 'true' : 'false');
    }

    function setMutedControl(muted) {
        const isMuted = Boolean(muted);
        mutedControlActive = isMuted;
        const control = modal().find('.modal-videocall-actions-mute');
        control
            .toggleClass('is-active', isMuted)
            .attr({
                'aria-pressed': isMuted ? 'true' : 'false',
                'aria-label': isMuted ? 'Unmute microphone' : 'Mute microphone',
            })
            .closest('.modal-videocall-actions-action')
            .find('.e-label')
            .text(isMuted ? 'Unmute' : 'Mute');
    }

    return {
        setState: setState,
        setConversationActive: setConversationActive,
        setMutedControl: setMutedControl,
        getState: function() { return currentState; },
    };
}
